import { render } from "./NodeDetailContent.vue?vue&type=template&id=1da1aa9b&scoped=true&ts=true"
import script from "./NodeDetailContent.vue?vue&type=script&lang=ts"
export * from "./NodeDetailContent.vue?vue&type=script&lang=ts"

import "./NodeDetailContent.vue?vue&type=style&index=0&id=1da1aa9b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da1aa9b"]])

export default __exports__